import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { digitalServicePageQueryOptions } from "~/app/api/pageData/digitalServicePageQuery";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";

function DigitalServiceRoute() {
  const result = useLoaderData({
    from: "/digitalService",
  }) as PageInitialData<void>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {null}
    </StorefrontShellFrame>
  );
}

export async function loadDigitalServicePageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(digitalServicePageQueryOptions());

  return unwrapPageInitialData(result);
}

export const digitalServiceRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/digitalService",
  loader: async ({ context }) => loadDigitalServicePageData(context),
  component: DigitalServiceRoute,
});
